module.exports = __webpack_public_path__ + "static/media/whitney.00fd27db.jpeg";